var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.420436 5.6025C0.930436 6.1125 1.74044 6.1625 2.29044 5.7025C6.96044 1.8625 13.7404 1.8625 18.4204 5.6925C18.9804 6.1525 19.8004 6.1125 20.3104 5.6025C20.9004 5.0125 20.8604 4.0325 20.2104 3.5025C14.5004 -1.1675 6.24044 -1.1675 0.520436 3.5025C-0.129564 4.0225 -0.179564 5.0025 0.420436 5.6025ZM8.18044 13.3625L9.65044 14.8325C10.0404 15.2225 10.6704 15.2225 11.0604 14.8325L12.5304 13.3625C13.0004 12.8925 12.9004 12.0825 12.3004 11.7725C11.0804 11.1425 9.62044 11.1425 8.39044 11.7725C7.82044 12.0825 7.71044 12.8925 8.18044 13.3625ZM4.45044 9.6325C4.94044 10.1225 5.71044 10.1725 6.28044 9.7625C8.72044 8.0325 12.0004 8.0325 14.4404 9.7625C15.0104 10.1625 15.7804 10.1225 16.2704 9.6325L16.2804 9.6225C16.8804 9.0225 16.8404 8.0025 16.1504 7.5125C12.7104 5.0225 8.02044 5.0225 4.57044 7.5125C3.88044 8.0125 3.84044 9.0225 4.45044 9.6325Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.6105532e615c4e737b9556c2007c6584.svg";
export { ForwardRef as ReactComponent };